import { render, staticRenderFns } from "./WriteComment.vue?vue&type=template&id=162c7161&"
import script from "./WriteComment.vue?vue&type=script&lang=ts&"
export * from "./WriteComment.vue?vue&type=script&lang=ts&"
import style0 from "./WriteComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports